import { appointmentColumn, messageColumn, leadColumn, employeeColumn, callColumn } from "../types";

export const CONVERSATION_COLUMNS: messageColumn[] = [
  {
    key: "createdAt",
    label: "Tiempo",
    width: "15%",
  },
  {
    key: "source",
    label: "Origen",
    width: "15%",
  },
  {
    key: "content",
    label: "Mensaje",
    width: "70%",
  },
];

export const CALL_COLUMNS: callColumn[] = [
  {
    key: "createdAt",
    label: "Fecha",
    width: "15%",
  },
  {
    key: "type",
    label: "Tipo",
    width: "15%",
  },
  {
    key: "status",
    label: "Estado",
    width: "15%",
  },
  {
    key: "durationMinutes",
    label: "Duración (min)",
    width: "15%",
  },
  {
    key: "transcript",
    label: "Transcripción",
    width: "40%",
  },
];

export const LEAD_COLUMNS: leadColumn[] = [
  {
    key: "createdAt",
    label: "Fecha de contacto",
    width: "15%",
  },
  {
    key: "name",
    label: "Nombre de contacto",
    width: "20%",
  },
  {
    key: "phone",
    label: "Teléfono",
    width: "10%",
  },
  {
    key: "pipelinePositionId",
    label: "Subestado",
    width: "15%",
  },
  {
    key: "alerts",
    label: "Alertas",
    width: "10%",
  },
  {
    key: "action1",
    label: "Detalle",
    width: "1fr",
  },
];

export const APPOINTMENT_COLUMNS: appointmentColumn[] = [
  {
    key: "employeeName",
    label: "Asesor",
    width: "15%",
  },
  {
    key: "leadName",
    label: "Prospecto",
    width: "15%",
  },
  {
    key: "leadPhone",
    label: "Celular",
    width: "15%",
  },
  {
    key: "listingCode",
    label: "Código",
    width: "7.5%",
  },
  {
    key: "date",
    label: "Fecha",
    width: "10%",
  },
  {
    key: "time",
    label: "Hora",
    width: "7.5%",
  },
  {
    key: "pipelinePosition",
    label: "Estado lead",
    width: "10%",
  },
  {
    key: "action1",
    label: "Gestionar prospecto",
    width: "20%",
  },
];

export const EMPLOYEES_COLUMNS: employeeColumn[] = [
  {
    key: "name",
    label: "Empleado",
    width: "15%",
  },
  {
    key: "phone",
    label: "Celular",
    width: "10%",
  },
  {
    key: "email",
    label: "Email",
    width: "1fr",
  },
  {
    key: "status",
    label: "¿Activo?",
    width: "1fr",
  },
  {
    key: "action1",
    label: "Activar",
    width: "1fr",
  },
  {
    key: "action2",
    label: "Desactivar",
    width: "1fr",
  },
  {
    key: "action3",
    label: "Editar",
    width: "5%",
  },
];
